export const BASE_URL_API = 'https://забгу.рф/api'
export const MEDIA_URL_API = 'https://забгу.рф' 

// export const BASE_URL_API = 'https://localhost/api'
// export const MEDIA_URL_API = 'https://localhost'

export default class APIClient {
    constructor() {
      this.baseURL = BASE_URL_API;
    }
  
    setAuthHeader(token) {
      this.headers = {
        'Authorization': `Bearer ${token}`
      };
    }
  
    async get(endpoint, params) {
      let headers = {}
      if(getCookie('token') != null) {
        headers['Authorization'] = 'Bearer ' + getCookie('token')
      }
      try {
        const response = await fetch(`${this.baseURL}/${endpoint}/?` + objectToParams(params), {
          method: 'GET',
          headers: {
            ...this.headers,
            ...headers
          }
        });
  
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
  
        return await response.json();
      } catch (error) {
        throw error;
      }
    }
  
    async post(endpoint, data, headers = {}) {
      try {
        if(getCookie('token') != null) {
          headers['Authorization'] = 'Bearer ' + getCookie('token')
        }
        const request = await fetch(`${this.baseURL}/${endpoint}`, {
          method: 'POST',
          headers: {
            ...headers,
          },
          body: data
        });
        return await request.json();
      } catch (error) {
        return await request.json();
      }
    }
    async put(endpoint, data, headers = {}) { 
      try {
        if(getCookie('token') != null) {
          headers['Authorization'] = 'Bearer ' + getCookie('token')
        }
        const request = await fetch(`${this.baseURL}/${endpoint}`, {
          method: 'PUT',
          headers: {
            ...headers
          },
          body: data
        });
        return await request.json();
      } catch (error) {
        return await request.json();
      }
    }
    async delete(endpoint, data) {
      let headers = {}
      try {
        if(getCookie('token') != null) {
          headers['Authorization'] = 'Bearer ' + getCookie('token')
        }
        const request = await fetch(`${this.baseURL}/${endpoint}`, {
          method: 'DELETE',
          headers: {
            ...this.headers,
            ...headers,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });
        return await request.json();
      } catch (error) {
        return await request.json();
      }
    }
  }

  function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
  
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  
    return null; // Return null if the cookie with the specified name is not found
  }
  
  function objectToParams(obj) {
    const params = [];
    
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value !== undefined) {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      }
    }
    
    return params.join('&');
  }